import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { AgentePublico, AgentePublicoPapel, CidadaoEmail } from '../models/acesso-cidadao.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AcessoCidadaoService extends BaseService {
    controllerRoute = 'AcessoCidadao';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getPapel(id: string): Promise<IBaseModel<AgentePublicoPapel>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublicoPapel>>(`${this.apiBaseUrl}/${this.controllerRoute}/Papel/${id}`));
    }

    public async getCidadaoEmail(id: string): Promise<IBaseModel<CidadaoEmail>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<CidadaoEmail>>(`${this.apiBaseUrl}/${this.controllerRoute}/Cidadao/${id}/Email`));
    }

    public async getConjuntoAgentesPublicos(id: string): Promise<IBaseModel<AgentePublico[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/Conjunto/${id}/AgentesPublicos`));
    }

    public async getConjuntoGestor(id: string): Promise<IBaseModel<AgentePublico>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico>>(`${this.apiBaseUrl}/${this.controllerRoute}/Conjunto/${id}/Gestor`));
    }

    public async getCidadaoExiste(cpf: string): Promise<IBaseModel<void>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<void>>(`${this.apiBaseUrl}/${this.controllerRoute}/Cidadao/${cpf}`));
    }

    public async getCidadaoSub(cpf: string): Promise<IBaseModel<AgentePublico>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico>>(`${this.apiBaseUrl}/${this.controllerRoute}/Cidadao/${cpf}/Sub`));
    }

    public async getRestritoCidadao(sub: string): Promise<IBaseModel<AgentePublico>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico>>(`${this.apiBaseUrl}/${this.controllerRoute}/Restrito/Cidadao/${sub}`));
    }
}
